

import { Alert, Box, Button, Card, CircularProgress, Container, Divider, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Radio, RadioGroup, Snackbar, TextField, Typography } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { authActions } from "../../store/reducer/auth-reducer";
import { Link, useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import AlertBar from "../../components/AlertBar";
import bankdetails from "../profile/bankdetails";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import { MobileDatePicker } from "@mui/x-date-pickers";
import RangeDatepicker from "../../components/RangeDatepicker";
import { reportsAction } from "../../store/reducer/reports";
import ReportList from "../../components/ReportList";
import { homePageActions } from "../../store/reducer/home";

const BidHistory = ({
    isBidReportLoading,
    bidData,
    isBidReportFailed }: any) => {
    const userDataSession: any = localStorage.getItem('userData');
    const finalData = JSON.parse(userDataSession);
    const [date_from, setDateFrom] = useState<Dayjs | null>(dayjs(new Date()));
    const [date_to, setDateTo] = useState<Dayjs | null>(dayjs(new Date()));
    const [bidList, setBidList] = useState<Array<any>>([]);
    const [errorMessage, setErrorMessage] = useState<any>({ status: false, message: '', severity: '', inputName: '' })
    const dispatch = useDispatch();
    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setErrorMessage({ status: false, message: "", severity: "", inputName: '' })
    };

    useEffect(() => {
        const payload: any = {
            app_key: "@34Y@#8deepmatka",
            bid_from: date_from?.toISOString(),
            bid_to: date_to?.toISOString(),
            user_id: finalData.user_id
        }
        dispatch(reportsAction.bidHistoryReq(payload))
        const pay: any = {
            menuname: 'mybids'
        }
        dispatch(homePageActions.selectedMenu(pay))
    }, [])

    useEffect(() => {
        if (bidData) {
            setBidList(bidData.bid_data)
        }
    }, [bidData])

    const getData = () => {
        const payload: any = {
            app_key: "@34Y@#8deepmatka",
            bid_from: date_from?.toISOString(),
            bid_to: date_to?.toISOString(),
            user_id: finalData.user_id
        }

        if (payload.bid_from != '' && payload.bid_to != '') {
            setErrorMessage({ status: false, message: "", severity: "", inputName: '' })
            dispatch(reportsAction.bidHistoryReq(payload))
        } else {
            setErrorMessage({ status: true, message: "Please choose date.", severity: "error", inputName: '' })
        }
    }
    return (
        <Container>
            <AlertBar handleClose={handleClose} errorMessage={errorMessage} />
            <Grid container>
                <RangeDatepicker date_from={date_from} date_to={date_to} setDateFrom={setDateFrom} setDateTo={setDateTo} handleClick={getData} />
            </Grid>
            <ReportList data={bidList} loading={isBidReportLoading} type={'bidhistory'} />
        </Container>
    )
}



const mapStateToProps = (state: any) => ({
    isBidReportLoading: state.reports.isBidReportLoading,
    bidData: state.reports.bidData,
    isBidReportFailed: state.reports.isBidReportFailed,
})


export default connect(mapStateToProps)(BidHistory);

